import React from "react";
import type { OAuthProviderIconProps } from "./OAuthProviderIcon.types";

/* Official multicolour marks. Fills are the providers' brand colours, which
   their guidelines require verbatim, so they are not design-system tokens. */

const GoogleMark = () => (
  <>
    <path d="M18.1711 10.1879C18.1711 9.36788 18.1003 8.78996 17.9473 8.18896H10.1992V11.5492H14.7991C14.7049 12.4547 14.1269 13.8097 12.8423 14.7269L12.8239 14.8507L15.4103 16.8371L15.5989 16.8556C17.2313 15.3542 18.1711 12.9721 18.1711 10.1879Z" fill="#4285F4" />
    <path d="M10.1993 19.0003C12.4518 19.0003 14.3369 18.2478 15.5989 16.8557L12.8424 14.727C12.2173 15.1579 11.3718 15.4591 10.1993 15.4591C7.99268 15.4591 6.12552 13.9577 5.53571 11.9006L5.41774 11.9103L2.72888 13.9681L2.69336 14.0802C3.94714 16.5564 6.87077 19.0003 10.1993 19.0003Z" fill="#34A853" />
    <path d="M5.53571 11.9006C5.38268 11.2996 5.29432 10.6633 5.29432 10.0003C5.29432 9.33722 5.38268 8.70087 5.52689 8.09987L5.52131 7.96815L2.79882 5.87573L2.69336 5.92026C2.04591 7.21456 1.6748 8.65945 1.6748 10.0003C1.6748 11.3411 2.04591 12.786 2.69336 14.0803L5.53571 11.9006Z" fill="#FBBC05" />
    <path d="M10.1993 4.54096C11.7019 4.54096 12.7181 5.19339 13.298 5.73807L15.6578 3.43437C14.3286 2.1988 12.4518 1.40027 10.1993 1.40027C6.87077 1.40027 3.94714 3.84414 2.69336 6.32028L5.52688 8.50001C6.12552 6.44284 7.99268 4.54096 10.1993 4.54096Z" fill="#EB4335" />
  </>
);

const MicrosoftMark = () => (
  <>
    <path d="M9.5 9.5H1.5V1.5H9.5V9.5Z" fill="#F25022" />
    <path d="M18.5 9.5H10.5V1.5H18.5V9.5Z" fill="#7FBA00" />
    <path d="M9.5 18.5H1.5V10.5H9.5V18.5Z" fill="#00A4EF" />
    <path d="M18.5 18.5H10.5V10.5H18.5V18.5Z" fill="#FFB900" />
  </>
);

const MARKS = { google: GoogleMark, microsoft: MicrosoftMark } as const;

/** Decorative provider mark; the surrounding button carries the name. */
export const OAuthProviderIcon: React.FC<OAuthProviderIconProps> = ({
  provider,
  size = 20,
}) => {
  const Mark = MARKS[provider];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-provider={provider}
    >
      <Mark />
    </svg>
  );
};

export default OAuthProviderIcon;
